type HomepageEventName =
  | 'homepage_hero_primary_cta_click'
  | 'homepage_hero_secondary_cta_click'
  | 'homepage_category_click'
  | 'homepage_featured_provider_click'
  | 'homepage_whatsapp_click'
  | 'homepage_provider_section_view'
  | 'homepage_provider_signup_cta_click';

type HomepageEventPayload = Record<string, string | number | boolean | undefined>;

export function trackHomepageEvent(eventName: HomepageEventName, payload: HomepageEventPayload = {}) {
  if (typeof window === 'undefined') {
    return;
  }

  const eventPayload = {
    ...payload,
    page_path: window.location.pathname,
  };

  const dataLayer = window.dataLayer ?? [];
  window.dataLayer = dataLayer;
  dataLayer.push({ event: eventName, ...eventPayload });

  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, eventPayload);
  }
}